module.exports = require("@swa-ui/placements/src/PlacementSection/PlacementSection.module.scss");